import dayjs from "dayjs";
import "dayjs/locale/nl";
import React, { useContext } from "react";
import logo from "../assets/logo-licom.png";
import GlobalContext from "../context/GlobalContext";
import ThemeToggle from "./ThemeToggle";

const views = [
  { value: "day", label: "Dag", short: "D" },
  { value: "week", label: "Week", short: "W" },
  { value: "month", label: "Maand", short: "M" },
];

export default function CalendarHeader({
  calendarView,
  setCalendarView,
  currentDate,
  onPrev,
  onNext,
  onToday,
  sidebarOpen,
  setSidebarOpen,
}) {
  const { currentUser, userLoading } = useContext(GlobalContext);

  dayjs.locale("nl");
  const weekNumber = currentDate.isoWeek
    ? currentDate.isoWeek()
    : currentDate.week
      ? currentDate.week()
      : currentDate.isoWeekNumber
        ? currentDate.isoWeekNumber()
        : currentDate.format("W");

  return (
    <header className="h-14 px-3 md:px-4 flex items-center gap-2 md:gap-3 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-x-auto">
      <button
        type="button"
        className="md:hidden btn-icon flex-shrink-0"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Menu"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </button>

      <img src={logo} alt="" className="hidden md:block w-8 h-8 md:w-9 md:h-9 flex-shrink-0" />
      <h1 className="hidden lg:block text-base font-semibold text-gray-800 dark:text-gray-100 flex-shrink-0">
        OnDuty
      </h1>

      <button type="button" onClick={onToday} className="btn-ghost whitespace-nowrap flex-shrink-0 text-xs md:text-sm">
        <span className="hidden sm:inline">Vandaag</span>
        <span className="sm:hidden">Vdg</span>
      </button>

      <div className="flex items-center flex-shrink-0">
        <button type="button" onClick={onPrev} className="btn-icon" aria-label="Vorige">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
            <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <button type="button" onClick={onNext} className="btn-icon" aria-label="Volgende">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
            <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button>
      </div>

      <h2 className="flex-1 text-sm md:text-base text-gray-700 dark:text-gray-200 font-semibold min-w-0 overflow-hidden truncate">
        {calendarView === "month" && (
          <>
            <span className="hidden sm:inline">{currentDate.locale("nl").format("MMMM YYYY")}</span>
            <span className="sm:hidden">{currentDate.locale("nl").format("MMM YY")}</span>
          </>
        )}
        {calendarView === "week" && (
          <>
            <span className="hidden sm:inline">{`Week ${weekNumber} ${currentDate.format("YYYY")}`}</span>
            <span className="sm:hidden">{`W${weekNumber} ${currentDate.format("YY")}`}</span>
          </>
        )}
        {calendarView === "day" && (
          <>
            <span className="hidden sm:inline">{currentDate.locale("nl").format("dddd, D MMMM YYYY")}</span>
            <span className="sm:hidden">{currentDate.locale("nl").format("D MMM")}</span>
          </>
        )}
      </h2>

      <div className="inline-flex rounded-lg border border-gray-200 dark:border-gray-700 p-0.5 flex-shrink-0">
        {views.map((view) => (
          <button
            key={view.value}
            type="button"
            onClick={() => setCalendarView(view.value)}
            className={`px-2 md:px-3 py-1 text-xs md:text-sm rounded-md transition-colors ${
              calendarView === view.value
                ? "bg-blue-500 text-white"
                : "text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
            }`}
          >
            <span className="hidden sm:inline">{view.label}</span>
            <span className="sm:hidden">{view.short}</span>
          </button>
        ))}
      </div>

      <div className="flex items-center gap-1 md:gap-2 flex-shrink-0">
        <ThemeToggle />
        {!userLoading && currentUser?.isAdmin && (
          <button
            type="button"
            onClick={() => { window.location.href = "/beheer"; }}
            className="hidden sm:inline-flex btn-ghost"
          >
            Beheer
          </button>
        )}
        <button
          type="button"
          onClick={() => { window.location.href = "/logout"; }}
          className="btn-ghost"
        >
          <span className="hidden sm:inline">Afmelden</span>
          <svg className="sm:hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
            <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
          </svg>
        </button>
      </div>
    </header>
  );
}
